import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const pays = ['Afghanistan','Afrique du Sud','Albanie','Algérie','Allemagne','Angola','Argentine','Australie','Autriche','Belgique','Bénin','Brésil','Bulgarie','Cameroun','Canada','Chili','Chine','Colombie','Congo','Corée du Sud','Côte d\'Ivoire','Croatie','Cuba','Danemark','Égypte','Espagne','États-Unis','Finlande','France','Gabon','Ghana','Grèce','Hongrie','Inde','Indonésie','Irak','Iran','Irlande','Islande','Israël','Italie','Jamaïque','Japon','Jordanie','Kenya','Liban','Luxembourg','Madagascar','Malaisie','Mali','Maroc','Mexique','Mozambique','Nigéria','Norvège','Nouvelle-Zélande','Pakistan','Pays-Bas','Pérou','Philippines','Pologne','Portugal','Qatar','Roumanie','Royaume-Uni','Russie','Sénégal','Singapour','Slovaquie','Suède','Suisse','Syrie','Taïwan','Tanzanie','Thaïlande','Tunisie','Turquie','Ukraine','Uruguay','Venezuela','Vietnam'];

const avatars = ['🎤','🎵','🌍','⭐','🎭','♥','🌙','✨','🎬','🎨'];

const inputStyle = { width: '100%', border: '2px solid #c49090', borderRadius: '8px', padding: '10px 13px', fontSize: '13px', color: '#1a1010', outline: 'none', fontFamily: 'Arial,sans-serif', background: '#fff' };
const labelStyle = { display: 'block', fontSize: '12px', fontWeight: '700', color: '#4a3030', marginBottom: '5px' };

export default function Inscription() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', email: '', password: '', country: '', fanSince: '', avatar: '🎤' });
  const [photo, setPhoto] = useState(null);
  const [cgu, setCgu] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    if (!form.username || !form.email || !form.password || !form.country) return setError('Veuillez remplir tous les champs obligatoires.');
    if (form.password.length < 8) return setError('Le mot de passe doit contenir au moins 8 caractères.');
    if (!cgu) return setError('Veuillez accepter les conditions d\'utilisation.');
    setError(''); setLoading(true);
    try {
      let photoUrl = '';
      if (photo) {
        const fd = new FormData();
        fd.append('file', photo);
        fd.append('upload_preset', 'mjfans');
        const cr = await axios.post('https://api.cloudinary.com/v1_1/' + process.env.REACT_APP_CLOUDINARY_CLOUD + '/image/upload', fd);
        photoUrl = cr.data.secure_url;
      }
      await register({ ...form, photo: photoUrl });
      setSuccess('Compte créé ! Vérifiez votre email pour confirmer votre inscription.');
    } catch (e) {
      setError(e.response?.data?.error || 'Une erreur est survenue.');
    }
    setLoading(false);
  };

  if (success) return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '40px', maxWidth: '440px', textAlign: 'center', border: '2px solid #c49090' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📧</div>
        <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#1a1010', marginBottom: '12px' }}>Vérifiez votre email !</h2>
        <p style={{ fontSize: '13px', color: '#4a3030', lineHeight: '1.8', marginBottom: '24px' }}>{success}</p>
        <Link to="/connexion"><button style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '11px 28px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>Se connecter →</button></Link>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', display: 'grid', gridTemplateColumns: '1fr 1fr' }}>

      {/* GAUCHE */}
      <div style={{ background: 'linear-gradient(135deg,#1a1010,#2a1518)', padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '120px', color: 'rgba(255,255,255,0.04)', fontFamily: 'Georgia,serif', lineHeight: 1 }}>"</div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#fff', marginBottom: '8px' }}>MJ <span style={{ color: '#e8a0a0' }}>—</span> Vu par ceux qui l'ont aimé</div>
        <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', lineHeight: '1.7', marginBottom: '32px' }}>Rejoignez la communauté de fans qui gardent la mémoire de Michael vivante.</div>
        {[
          { icon: '✦', title: 'Partagez vos témoignages', text: 'Racontez vos souvenirs, vos rencontres, vos "Et si…"' },
          { icon: '💬', title: 'Commentez et répondez', text: 'Réagissez aux témoignages d\'autres fans du monde entier.' },
          { icon: '❤️', title: 'Aimez et suivez', text: 'Retrouvez vos témoignages favoris dans votre profil.' },
          { icon: '🌍', title: 'Communauté mondiale', text: 'Des fans de plus de 80 pays réunis ici.' },
        ].map((b, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '14px' }}>
            <div style={{ fontSize: '18px', flexShrink: 0 }}>{b.icon}</div>
            <div>
              <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff', marginBottom: '2px' }}>{b.title}</div>
              <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)' }}>{b.text}</div>
            </div>
          </div>
        ))}
      </div>

      {/* DROITE */}
      <div style={{ padding: '40px', overflowY: 'auto' }}>
        <div style={{ display: 'flex', gap: '0', marginBottom: '28px', border: '2px solid #8b1a2a', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ flex: 1, padding: '10px', textAlign: 'center', fontSize: '14px', fontWeight: '700', background: '#8b1a2a', color: '#fff' }}>Créer un compte</div>
          <Link to="/connexion" style={{ flex: 1, padding: '10px', textAlign: 'center', fontSize: '14px', fontWeight: '700', background: '#fff', color: '#8b1a2a', textDecoration: 'none', display: 'block' }}>Se connecter</Link>
        </div>

        <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#1a1010', marginBottom: '6px' }}>Rejoindre la communauté</h2>
        <p style={{ fontSize: '13px', color: '#6a5050', marginBottom: '20px' }}>Gratuit, sans pub, pour les fans de Michael.</p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>

          <div><label style={labelStyle}>Pseudonyme *</label><input style={inputStyle} placeholder="MJfan84" value={form.username} onChange={e => update('username', e.target.value)} /></div>
        </div>

        <div style={{ marginBottom: '14px' }}><label style={labelStyle}>Email *</label><input style={inputStyle} type="email" placeholder="marie@email.com" value={form.email} onChange={e => update('email', e.target.value)} /></div>
        <div style={{ marginBottom: '14px' }}><label style={labelStyle}>Mot de passe * (8 caractères min.)</label><input style={inputStyle} type="password" placeholder="••••••••" value={form.password} onChange={e => update('password', e.target.value)} /></div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
          <div>
            <label style={labelStyle}>Pays *</label>
            <select style={inputStyle} value={form.country} onChange={e => update('country', e.target.value)}>
              <option value="">Sélectionner…</option>
              {pays.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div><label style={labelStyle}>Fan de MJ depuis</label><input style={inputStyle} placeholder="1984" value={form.fanSince} onChange={e => update('fanSince', e.target.value)} /></div>
        </div>

        <div style={{ marginBottom: '14px' }}>
          <label style={labelStyle}>Photo de profil (optionnel)</label>
          <input type="file" accept="image/*" onChange={e => setPhoto(e.target.files[0])} style={{ fontSize: '12px', color: '#4a3030' }} />
          {photo && <div style={{ fontSize: '12px', color: '#8b1a2a', marginTop: '4px' }}>✓ {photo.name}</div>}
        </div>

        <div style={{ marginBottom: '14px' }}>
          <label style={labelStyle}>Avatar (si pas de photo)</label>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '6px' }}>
            {avatars.map(a => (
              <div key={a} onClick={() => update('avatar', a)} style={{ width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', border: `2px solid ${form.avatar === a ? '#8b1a2a' : '#c49090'}`, background: form.avatar === a ? '#f5eeeb' : '#fff', cursor: 'pointer' }}>{a}</div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '14px' }}>
          <input type="checkbox" checked={cgu} onChange={e => setCgu(e.target.checked)} style={{ marginTop: '2px', accentColor: '#8b1a2a', width: '15px', height: '15px', flexShrink: 0 }} />
          <label style={{ fontSize: '12px', color: '#4a3030', lineHeight: '1.6' }}>
            J'ai 18 ans ou plus et j'accepte les <Link to="/cgu" style={{ color: '#8b1a2a', fontWeight: '700' }}>conditions d'utilisation</Link> et la <Link to="/confidentialite" style={{ color: '#8b1a2a', fontWeight: '700' }}>politique de confidentialité</Link>. *
          </label>
        </div>

        {error && <div style={{ background: '#fff0f0', border: '1px solid #e08080', borderRadius: '7px', padding: '10px 14px', fontSize: '12px', color: '#a03030', marginBottom: '12px' }}>{error}</div>}

        <button onClick={handleSubmit} disabled={loading} style={{ background: loading ? '#c49090' : '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', width: '100%' }}>
          {loading ? 'Création en cours…' : '✦ Créer mon compte'}
        </button>

        <div style={{ textAlign: 'center', fontSize: '12px', color: '#6a5050', marginTop: '14px' }}>
          Déjà un compte ? <Link to="/connexion" style={{ color: '#8b1a2a', fontWeight: '700' }}>Se connecter →</Link>
        </div>
      </div>
    </div>
  );
}
